export default function distributeItemsButtonHandler() {
  const $button = $('#js-distribute-items');
  const $spinner = $('.js-spinner ');
  const beforeSendHandler = function() {
    $(this)
      .addClass('__disabled')
      .css('color', 'grey');

    // $('#result-message ').text('#{t('views.orders.actions.distribute_items.sending')}')
    $spinner.show();
  };

  const completeHandler = function(_event, xhr) {
    const json = xhr.responseJSON;
    $('#result-message').text(json.message);
    $spinner.hide();
  };

  $button.on('ajax:beforeSend', beforeSendHandler);
  $button.on('ajax:complete', completeHandler);

  return () => {
    $button.off('ajax:beforeSend', beforeSendHandler);
    $button.off('ajax:complete', completeHandler);
  };
};
